<template>
  <div class="app-container">

    <!-- 添加或修改行业速递对话框 -->
    <el-card>
      <el-row>
        <div class="new-title">
          {{form.newsTitle}}
        </div>
      </el-row>
      <el-row>
        <div class="new-text" v-html="form.newsText">
          <!--{{form.newsText}}-->
        </div>
      </el-row>

      <!--<p>&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; {{testVal}}</p>-->
      <!--<div style="height: 200px; width: 100%">-->
        <!--&lt;!&ndash;<el-button type="primary" @click="submitForm">确 定</el-button>&ndash;&gt;-->
        <!--<el-button @click="cancel" style="margin: auto">返回</el-button>-->
      <!--</div>-->
    </el-card>
  </div>
</template>

<script>
// import TinymceEditor from '../../components/tinymce-editor/index'
export default {
  name: 'NewsInfo',
  // components: { TinymceEditor },
  data () {
    return {
      testVal: '',
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 行业速递表格数据
      newsList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        newsTitle: null,
        newsText: null,
        status: null,
        remark: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        newsTitle: [
          { required: true, message: '新闻标题不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // this.getList();
    this.getNewsInfo(this.$route.query.newsId)
  },
  methods: {
    /** 查询行业速递列表 */
    // getList() {
    //   this.loading = true;
    //   listNews(this.queryParams).then(response => {
    //     this.newsList = response.rows;
    //     this.total = response.total;
    //     this.loading = false;
    //   });
    // },
    // 取消按钮
    // cancel () {
    //   // this.open = false;
    //   // this.reset();
    //   this.$router.push('/news/manage')
    // },
    // 表单重置
    reset () {
      this.form = {
        newsId: null,
        newsTitle: null,
        newsText: null,
        status: '0',
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null
      }
      this.resetForm('form')
    },

    getNewsInfo (newsId) {
      this.$get('/system/news/' + newsId)
        .then(response => {
          // console.log('res=====', response)
          this.form = response.data.data
        })
    }
  }
}
</script>

<style lang="less" scoped>
  .new-title{
    width: 800px;
    height: auto;
    /*padding: 0 25%;*/
    margin: auto;
    text-align: center;
    font-size: 24px;
    word-break: break-all;
    word-wrap: break-word;
    text-align-last: left;
  }
  .new-text{
    width: 800px;
    height: 100%;
    margin: 50px auto;
    /*padding: 3% 25%;*/
    min-height: 300px;
    box-sizing:border-box
  }
</style>
